'use client';

import { useCallback } from 'react';
import { MarketType } from '@drift-labs/sdk';
import { ENUM_UTILS, UIMarket } from '@drift/common';
import { useSwitchMarket } from 'src/hooks/driftActions/market/useSwitchMarket';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { PageRoute } from 'src/constants/constants';
import { AccountOrder } from '../types';

interface MarketCellProps {
	order: AccountOrder;
}

export function MarketCell({ order }: MarketCellProps) {
	const { switchMarket } = useSwitchMarket();
	const isOnTradePage = useDriftStore(
		(s) => s.currentPageRoute === PageRoute.trade
	);

	const isSpot = ENUM_UTILS.match(order.marketType, MarketType.SPOT);
	const uiMarket = new UIMarket(order.marketIndex, order.marketType);
	const marketName = isSpot
		? `${uiMarket.uiSymbols.baseAssetDisplaySymbol}-SPOT`
		: uiMarket.uiSymbols.baseAssetDisplaySymbol;

	const handleClick = useCallback(
		(e: React.MouseEvent<HTMLSpanElement>) => {
			e.stopPropagation();
			switchMarket({
				marketIndex: order.marketIndex,
				marketType: order.marketType,
				goToTradePage: !isOnTradePage,
			});
		},
		[order.marketIndex, order.marketType, isOnTradePage, switchMarket]
	);

	return (
		<span className="cursor-pointer uppercase" onClick={handleClick}>
			{marketName}
		</span>
	);
}
